module.exports = __webpack_public_path__ + "static/img/profile_base.f46b1c9a.png";